import { createFileRoute, redirect } from '@tanstack/react-router'

// /landing was the pre-redesign dashboard route. Redirect bookmarks to /dashboard.
export const Route = createFileRoute('/_auth/landing')({
  beforeLoad: () => {
    throw redirect({ to: '/dashboard', replace: true })
  },
})
